/**
 * Chi sta usando il sito.
 *
 * L'identificativo sta nel token, che c'è sempre dopo l'accesso. Prima ogni
 * pagina lo leggeva da localStorage, dove finiva solo se una chiamata al
 * profilo riusciva: quando quella falliva le pagine chiedevano i dati di
 * nessuno e mostravano schermate vuote senza spiegare perché.
 */

function fromToken() {
  const token = typeof window !== 'undefined'
      ? window.localStorage.getItem('access_token') : null;
  if (!token) return null;

  try {
    const payload = JSON.parse(
        atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));

    /* UN GETTONE SCADUTO NON E' UN ACCESSO.
       Nessuno lo cancella quando scade: resta li' e continua a dire chi sei.
       Il sito ci credeva -- il menu in alto mostrava Accedi e Registrati, e
       nello stesso momento la schedina chiedeva i limiti di un utente e si
       prendeva un 401, quindi a chi non aveva fatto l'accesso compariva
       "Limiti di gioco non disponibili in questo momento". Due idee diverse
       di "sono collegato" nella stessa pagina.
       `exp` sta in secondi, non in millisecondi. Un gettone senza `exp` si
       lascia passare: e' chi lo emette a decidere, non noi. */
    if (payload && payload.exp && Number(payload.exp) * 1000 <= Date.now()) {
      return null;
    }
    return payload;
  } catch (e) {
    return null;
  }
}

export function getCurrentUserId() {
  const payload = fromToken();
  if (!payload) {
    /* NIENTE RIPIEGO SU USER_ID.
       C'era: "se il token non c'e', tanto vale provare". Ma senza gettone non
       si puo' chiamare niente, quindi quell'identificativo non serviva a
       riuscire in qualcosa -- serviva solo a far credere al sito che ci fosse
       qualcuno collegato. Il risultato era una pagina che chiede dati per
       conto di un utente che non puo' dimostrare di essere lui, e messaggi di
       errore a chi sta solo guardando le quote.
       Uscendo, USER_ID viene cancellato insieme al gettone: quando resta
       indietro e' perche' il gettone e' scaduto o e' sparito, e in tutti e
       due i casi la risposta giusta e' "non c'e' nessuno". */
    return null;
  }
  return payload.userId || payload.sub || null;
}

export function getCurrentUsername() {
  /* Senza un gettone valido non c'e' nemmeno un nome da mostrare: leggerlo da
     localStorage vorrebbe dire scrivere "ciao Mario" in cima a una pagina che
     per tutto il resto lo tratta da ospite. */
  const payload = fromToken();
  return (payload && payload.username) || null;
}

/**
 * L'OPERATORE AL COMPUTER (Accesso al sito, 4 novembre 2026): null quando chi
 * e' entrato e' il titolare del conto; {id, username} quando un operatore del
 * backoffice sta usando il sito con il conto di un altro. Lo dice il gettone
 * (claim «operatore», messo da user-management): il sito non lo decide da se'.
 */
export function getOperatore() {
  const payload = fromToken();
  if (!payload || !payload.operatore) return null;
  return {
    id: String(payload.operatore),
    username: payload.operatoreUsername ? String(payload.operatoreUsername) : '',
  };
}

/** La posizione nella rete: AGENTE, MASTER, PLAYER e così via. */
export function getCurrentNetworkLevel() {
  const payload = fromToken();
  return (payload && payload.networkLevel) || '';
}

export function getCurrentPermissions() {
  const payload = fromToken();
  return payload && Array.isArray(payload.permissions) ? payload.permissions : [];
}

/**
 * I livelli di chi gioca, senza nessuno sotto di sé. Sono gli stessi che la
 * schedina già considera giocatori (SchedinaCollegata): un conto aperto dal
 * backoffice porta WEB_USER, non PLAYER, e prima il sito lo trattava da
 * operatore («Disp.» al posto di «Saldo», niente saldo bonus).
 */
const LIVELLI_GIOCATORE = ['PLAYER', 'WEB_USER', 'GIOCATORE'];

/** Una posizione senza nessuno sotto di sé. */
export function isPlayer() {
  return LIVELLI_GIOCATORE.includes(String(getCurrentNetworkLevel()).toUpperCase());
}

/**
 * Nessuno ha fatto l'accesso.
 *
 * Serve alla barra in basso: senza questa, chi arriva senza conto finiva nel
 * ramo degli operatori e si vedeva "Conto" e "Profilo" -- due voci che
 * portano soltanto alla schermata di accesso, cioe' un tocco per trovare una
 * porta chiusa.
 */
export function eOspite() {
  return !getCurrentUserId();
}
